export enum Actions {
  ACTIONS_POST_LOGIN = 'ACTIONS_POST_LOGIN',
  ACTIONS_TOGGLE_SIDEBAR_MOBILE = 'ACTIONS_TOGGLE_SIDEBAR_MOBILE',
  ACTIONS_TOGGLE_SIDEBAR_DEKSTOP = 'ACTIONS_TOGGLE_SIDEBAR_DEKSTOP',
  ACTIONS_LOGOUT = 'ACTIONS_LOGOUT',
  ACTIONS_REFRESH_TOKEN = 'ACTIONS_REFRESH_TOKEN',
  ACTIONS_FORGOT_PASSWORD = 'ACTIONS_FORGOT_PASSWORD',
}